import type { ScrapingIntentSummary } from '../types';

import { internalApiClient } from '@/shared/api-client/internal-api-client';
// periodic 전용: 스케줄링을 시작 (다시 run을 생성한다)
export async function reactivateScrapingIntent(intentId: string): Promise<ScrapingIntentSummary> {
  const response = await internalApiClient.post<ScrapingIntentSummary>(
    `scraping-intents/${intentId}/reactivate`,
  );

  return response.json();
}
